import { computed } from "vue";
import { getApiErrorCode } from "@/infrastructure/services/ApiErrorService";
import { SHARED_EMAIL_DISABLED_ERROR_CODE } from "../domain/entities/sharedEmailSetting";
import { useSharedEmailSettingStore } from "../stores/useSharedEmailSettingStore";
/**
 * Whether the screens writing a contact's email (contact, reception) may offer the "share this
 * email" opt-in. The value is cached for the session; call `loadSharedEmailSetting` each time
 * such a screen opens, so an administrator's change is seen.
 */
export function useSharedEmailSetting() {
    const store = useSharedEmailSettingStore();
    /** Call from the catch of an email write: a share refused as disabled withdraws the opt-in. */
    function onEmailWriteRejected(error) {
        if (getApiErrorCode(error) === SHARED_EMAIL_DISABLED_ERROR_CODE)
            store.remember(false);
    }
    return {
        sharedEmailsEnabled: computed(() => store.enabled),
        /** True until the first read of the session settles: the screen must not conclude yet. */
        sharedEmailSettingPending: computed(() => !store.settled),
        loadSharedEmailSetting: store.load,
        onEmailWriteRejected,
    };
}
